// extracted by mini-css-extract-plugin
export default {"leave":"IXEcT4","leaveActive":"dCUDPV"};